<template>
  <Modal ref="modal">
    <div class="modal__header">
      <div class="header__checkbox_container">
        <div class="header__checkbox"></div>
      </div>
      <div class="header__left">
        <div class="header__top">#123456</div>
        <div class="header__bottom">R-Center-01</div>
      </div>
      <div class="header__right">
        <div class="header__top">9:17 AM</div>
        <div class="header__bottom">Take-out | 00 min</div>
      </div>
      <div class="header__actions">
        <div class="header__action" @click="close">
          <svgicon src="/icon/close.svg" :width="24" :height="24"></svgicon>
        </div>
      </div>
    </div>
    <div class="modal__order_container">
      <KDSItem class="modal__order" v-for="n in 20" :key="`order-${n}`"></KDSItem>
    </div>
    <ModalFooter>
      <ModalFooterPagination backText="close" @back="close"></ModalFooterPagination>
    </ModalFooter>
  </Modal>
</template>

<script>
  import KDSItem from "./KDSItem.vue";
  import Modal from "../modal/Modal.vue";
  import ModalFooter from "../modal/ModalFooter.vue";
  import ModalFooterPagination from "../modal/ModalFooterPagination.vue";

  export default {
    name: "ModalKDSOrderDetails",
    components: { Modal, ModalFooter, ModalFooterPagination, KDSItem },
    methods: {
      show() {
        this.$refs.modal.show();
      },
      close() {
        this.$refs.modal.hide();
      }
    }
  };
</script>

<style lang="scss" scoped>
.modal__header {
  margin: -40px -40px 0;
  background-color: var(--primary-color);
  color: white;
  padding: 20px 40px;
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
  margin-bottom: 30px;
  height: 100px;
  display: flex;
  align-items: center;

  .header__left {
    flex-grow: 1;
    margin-right: 40px;
  }

  .header__right {
    text-align: right;
  }

  .header__top {
    font-size: 40px;
    font-weight: 900;
  }

  .header__bottom {
    font-size: 20px;
    font-weight: 500;
  }

  .header__checkbox {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid white;
    margin-right: 40px;
  }

  .header__actions {
    fill: white;
    margin-left: 40px;
    cursor: pointer;
  }
}

.modal__order_container {
  max-height: 530px;
  min-height: 530px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 10px;
  max-width: 1300px;
  min-width: 1300px;
  overflow-x: auto;
}

.modal__order {
  padding: 20px;
  border: 1px solid #E6E6E6;
  border-radius: 12px;
}
</style>